import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { undoTreeEdits } from 'store/slices/TreeSlice';
import CustomUndoBtn from 'components/tool/Editor/ButtonDiv/UndoButton';

export default function TreeUndoButton({ disabled: externalDisabled }: { disabled?: boolean }) {
	const dispatch = useDispatch();
	const { history, currentIndex } = useSelector((state: RootState) => state.treeSlice.data);

	const disabled = currentIndex <= 0 || !!externalDisabled;
	const show = history.length > 1;

	if (!show) return null;

	return (
		<CustomUndoBtn
			id="undo"
			disabled={disabled}
			onClick={() => dispatch(undoTreeEdits())}
		/>
	);
}
